import * as SurveyVue from 'survey-vue'
SurveyVue.JsonObject.metaData.addProperty("survey", { name: "color:string", default: "" })
SurveyVue.JsonObject.metaData.addProperty("page", { name: "pageClass:string", default: "" })
SurveyVue.JsonObject.metaData.addProperty("question", { name: "specialClass:string", default: "" })
SurveyVue.JsonObject.metaData.addProperty("text", { name: "upperChoice:string", default: "Upper choice" })
SurveyVue.JsonObject.metaData.addProperty("text", { name: "lowerChoice:string", default: "Lower choice" })
console.log(SurveyVue);
import $ from 'jquery'
import db from '@/db'

const surveyHelper = {}
export default surveyHelper.install = function(Vue, options) {
    Vue.prototype.$postData = (survey, authID, timelog) => {
        console.log(">>>>>> UPLOAD")
        console.log(survey.data)
        let data = survey.data
        if (timelog != undefined) {
            data.timestamps = timelog
        }
        // POST TO FIREBASE
        db.ref(`polls/${authID}/${survey.title}`).set(data, () => {
            console.log("<<<<<< SUCCESS")
        })
        if (survey.title == 'Biometrics') {
            db.ref(`profiles/${authID}/name`).set(survey.data.name, () => {
                console.log(">>>>>> Update name")
            })
        }
    }
    Vue.prototype.$updateSurvey = (survey) => {
        console.log(">>>>>> SAVE SURVEY")
        console.log(survey)
        let data = survey
        // POST TO FIREBASE
        db.ref(`surveys/${survey.title}`).set(data, () => {
            console.log("<<<<<< SURVEY SAVED");
        })
    }
    Vue.prototype.$downloadSurveys = function() {
        // GET SURVEY
        console.log("<<<<<< GET SURVEYS")
		return new Promise((resolve, reject) => {
			db.ref(`surveys`).once('value').then((snap) => {
				resolve(snap.val())
			}).catch((error) => {
				reject(error);
			})
		})
    }

    var surveys = null

    function unWidow(str) {
        // Strip out Vertical Slider {} and remove blanks
        let wordArray = str.split(" {")[0].split(" ").filter(a => a !== "")
        let correctedStr = ""
        for (let i = 0; i <= wordArray.length-1; i++) {
            correctedStr += wordArray[i]
            if (i == (wordArray.length-2)) {
                correctedStr += "&nbsp;"
            } else { 
                correctedStr += " "
            }
        }
        return correctedStr
    }

    function getSurveyModel(surveyTitle) {
        console.log("LOAD MODEL: "+surveyTitle)
        let model = new SurveyVue.Model(surveys[surveyTitle])
        model.onAfterRenderQuestion .add((sender, options) => {
            // add the survey question title as a class
            let qname = options.question.name
            $(options.htmlElement).addClass(qname)
            // swap "<br/>" for actual breaks
            let find = '&lt;br/&gt;'
            var re = new RegExp(find, 'g')
            if ($(options.htmlElement.children[0]).find('h5 span span').html()) {
                let str = $(options.htmlElement.children[0]).find('h5 span span').html().replace(re,'<br/>') // Only the question title
                $(options.htmlElement.children[0]).find('h5 span span').html(unWidow(str))
            }
        })
        let cor = model.color? model.color: "#FFFFFF"
        console.log(cor);
        return {survey:model, ledColor:cor}
    }

    Vue.prototype.$getSurvey = (surveyTitle) => {
        return new Promise((resolve, reject) => {
            if (!surveys) {
                db.ref(`surveys`).once('value').then((snap) => {
                    surveys = snap.val()
                    let model = getSurveyModel(surveyTitle)
                    resolve(model)
                }).catch((error) => {
                    reject(error);
                })
            } else {
                let model = getSurveyModel(surveyTitle)
                resolve(model)
            }
		})
    }
}